import {useSelector} from "react-redux"
import {EDITOR_MODE_HTML} from "../../constants/EditorMode"
import React from "react"
import {isDaumBlogDomain} from "../../lib/UriUtil";


export default function HelpButton() {
  const editorMode = useSelector(state => state.env.editorMode)

  if (isDaumBlogDomain() || editorMode !== EDITOR_MODE_HTML) {
    return null
  }

  return (
    <a className="btn_type1" href='https://notice.tistory.com/category/%ED%8B%B0%EC%8A%A4%ED%86%A0%EB%A6%AC%20%EA%B0%80%EC%9D%B4%EB%93%9C/%EA%B4%80%EB%A6%AC%20%3A%20%EA%B8%80%EC%93%B0%EA%B8%B0' target='_blank'>
      <span className="mce-ico ico_help" />
      <span className="btn_txt">도움말</span>
    </a>
  )
}
